import { makeStyles, Typography } from "@material-ui/core";
import classnames from "classnames";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: "center",
    background: theme.palette.warning.main,
    borderRadius: "4px",
    display: "flex",
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    height: "fit-content",
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
}

/**
 * Styled Typography specifically for displaying information
 * on pending investigations such as, the number of them or if
 * an investigation is in the requested state.
 */
const RequestedBubble = ({ children, className }: Props) => {
  const classes = useStyles();

  return (
    <Typography
      className={classnames(classes.root, className)}
      variant="body2"
      data-testid="investigation-requested-bubble"
    >
      {children}
    </Typography>
  );
};

RequestedBubble.defaultProps = {
  className: undefined,
};

export default RequestedBubble;
